import { VertexList } from "../imw/vertex-list";

/**
 * Produces the beveled edge band geometry when combined with a plan edge list
 * using the SweptMesh class.
 *
 * Here the width is the width of the edgeband, i.e. the thickness of the panel
 * on which it is attached. The thickness of the edgeband will be its extent
 * outward from the plan. The edge banding will contribute twice its thickness
 * to the height and depth of the plan, thus the plan must be reduced in
 * dimension and offset to accomodate this and end up at the given final
 * dimensions.
 */
export const generateEdgebandProfile = (
    profile: VertexList, width: number, thickness: number) =>
{
    //   \  (thickness, width-thickness) -> (0, width)
    //   |
    //   |
    //   /  (0, 0) -> (thickness, thickness)

    profile.moveTo(0, 0);
    profile.edgeTo(thickness, thickness);
    profile.edgeTo(thickness, width - thickness);
    profile.edgeTo(0, width);
}
